import React from 'react';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export const Container = React.forwardRef<HTMLDivElement, Props>(({ children, className, ...props }, ref) => (
  <div className={`mx-auto container bg-background text-foreground ${className || ''}`} {...props} ref={ref}>
    {children}
  </div>
));

Container.displayName = 'Container';
